import { memo, useMemo } from "react";

import { PlainReservationComponentType } from "@/lib/gql/__generated__/graphql";

import { LikeReservationComponentCalendar } from "./calendar";
import { LikeReservationComponentInline } from "./inline";

type Props = {
	primaryColor: string;
	plainReservationComponentType: PlainReservationComponentType;
};

// 予約 Component 風な Component
export const LikeReservationComponent = memo(({ primaryColor, plainReservationComponentType }: Props) => {
	const canShowInline = useMemo(
		() => plainReservationComponentType === PlainReservationComponentType.Inline,
		[plainReservationComponentType],
	);

	return canShowInline ? (
		<LikeReservationComponentInline primaryColor={primaryColor} />
	) : (
		<LikeReservationComponentCalendar primaryColor={primaryColor} />
	);
});
